import React from "react";

import { Link } from "react-router-dom";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/src/components/ui/carousel";

import videoPlaceholder from "../../resources/video_placeholder.jpg";

import type { JSX } from "react";

export interface CastingCarouselItem {
  id: string;
  imageUrl?: string | null;
  label?: string;
  to?: string;
}

interface CastingCarouselProps {
  items: CastingCarouselItem[];
}

export default function CastingCarousel({
  items,
}: CastingCarouselProps): JSX.Element {
  return (
    <div className="px-12">
      <Carousel opts={{ align: "start", loop: true, slidesToScroll: "auto" }}>
        <CarouselContent>
          {items.map((item) => {
            const thumbnail = (
              <img
                alt=""
                className="aspect-video w-full rounded-md object-cover"
                src={item.imageUrl ?? videoPlaceholder}
              />
            );

            const content = item.label ? (
              <div className="flex flex-col gap-1">
                {thumbnail}
                <span className="truncate text-center text-sm">
                  {item.label}
                </span>
              </div>
            ) : (
              thumbnail
            );

            return (
              <CarouselItem
                key={item.id}
                className="basis-1/2 sm:basis-1/3 md:basis-1/4 lg:basis-1/6"
              >
                {item.to ? <Link to={item.to}>{content}</Link> : content}
              </CarouselItem>
            );
          })}
        </CarouselContent>
        <CarouselPrevious className="border-none" />
        <CarouselNext className="border-none" />
      </Carousel>
    </div>
  );
}
